import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/create.svg
 */
const IconCreate: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M12 24a12 12 0 1112-11.998A12.033 12.033 0 0112 24zm0-22.515a10.517 10.517 0 1010.517 10.517A10.546 10.546 0 0012 1.485z"
      fill="currentColor"
    />
    <path
      d="M18.25 12.343a.73.73 0 01-.729.731h-4.447v4.447a.73.73 0 01-.73.731h-.437a.733.733 0 01-.73-.73v-4.448H6.73a.73.73 0 01-.73-.73v-.437a.727.727 0 01.73-.729h4.447V6.731a.731.731 0 01.73-.731h.436a.73.73 0 01.73.73v4.448h4.448a.729.729 0 01.73.729v.436z"
      fill="currentColor"
    />
  </svg>
);

export default IconCreate;
